import React, { useId } from 'react';
import './SectionCurve.css';

export type SectionCurveTone = 'primary' | 'secondary' | 'contact';

interface SectionCurveProps {
  /** Background of the section above the curve */
  from: SectionCurveTone;
  /** Background of the section below the curve */
  to: SectionCurveTone;
  /** Hide the upper fill — use when the section above supplies its own curved edge (e.g. hero image) */
  hideBase?: boolean;
  /** Pull the curve under the previous section (hero → services) */
  overlap?: boolean;
  accent?: boolean;
}

const SectionCurve: React.FC<SectionCurveProps> = ({
  from,
  to,
  hideBase = false,
  overlap = false,
  accent = true,
}) => {
  const accentGradientId = useId();

  return (
    <div
      className={`section-curve${overlap ? ' section-curve--overlap' : ''}`}
      aria-hidden="true"
    >
      <svg viewBox="0 0 1440 80" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id={accentGradientId} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="rgba(255, 140, 0, 0)" />
            <stop offset="45%" stopColor="rgba(255, 140, 0, 0.22)" />
            <stop offset="55%" stopColor="rgba(255, 140, 0, 0.22)" />
            <stop offset="100%" stopColor="rgba(255, 140, 0, 0)" />
          </linearGradient>
        </defs>

        {!hideBase && (
          <rect className={`section-curve-base section-curve-base--${from}`} width="1440" height="80" />
        )}

        <path
          className={`section-curve-wave section-curve-wave--${to}`}
          d="M0,0 C480,76 960,76 1440,0 L1440,80 L0,80 Z"
        />

        {accent && (
          <path
            className="section-curve-accent"
            d="M0,1 C480,68 960,68 1440,1"
            fill="none"
            stroke={`url(#${accentGradientId})`}
            strokeWidth="1.5"
            vectorEffect="non-scaling-stroke"
          />
        )}

        <path
          className="section-curve-highlight"
          d="M0,0 C480,64 960,64 1440,0"
          fill="none"
          stroke="currentColor"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    </div>
  );
};

export default SectionCurve;
